import styled from "styled-components";
import { Button } from "@mui/material";

import { breakpoints } from "@/styles/breakpoints";

export const StyledAddressChangeForm = styled.div`
    padding-bottom: 40px;

    form {
        .formControl {
            margin-bottom: 15px;

            .MuiFormHelperText-root {
                color: var(--color-error);
            }
        }

        .relationsText {
            font-size: var(--size-14);
            line-height: 19px;
            color: var(--color-grey-900);
        }
    }
`;

export const StyledAddressChangeButton = styled(Button)`
    float: right;
    width: 280px;
    margin-bottom: 20px;

    @media ${breakpoints.xs} {
        float: unset;
        width: 100%;
    }
`;
